document.addEventListener('DOMContentLoaded', () => {
    const headerMenu = document.querySelector('.header-menu');
    const menuItems = document.querySelectorAll('.header-menu > li');
    const subMenus = document.querySelectorAll('.header-menu > li .sub-menu');

    let hasHovered = false;

    // Öppna en meny-item
    function openMenu(item) {
        const wrapper = item.querySelector('.sub-menu-wrapper');

        if (!hasHovered) {
            subMenus.forEach(submenu => {
                submenu.classList.remove('opacity-0', 'invisible');
            });
            hasHovered = true;
        }

        if (wrapper) wrapper.classList.remove('hidden');
    }

    // Stäng en meny-item
    function closeMenu(item) {
        const wrapper = item.querySelector('.sub-menu-wrapper');
        if (wrapper) wrapper.classList.add('hidden');
    }

    // Stäng alla submenyer
    function closeAllMenus() {
        subMenus.forEach(submenu => {
            submenu.classList.add('opacity-0', 'invisible');
        });

        document.querySelectorAll('.sub-menu-wrapper').forEach(w => {
            w.classList.add('hidden');
        });

        hasHovered = false;
    }

    // Öppna första menyn (för #header-menu-länk)
    function triggerFirstMenu() {
        const firstItem = document.querySelector('.header-menu > li');
        if (firstItem) {
            openMenu(firstItem);

            // Sätt fokus på första länk i menyn (tillgänglighet)
            const firstLink = firstItem.querySelector('a, button');
            if (firstLink) firstLink.focus();
        }
    }

    // Hantera mus och tangentbord (focus-within)
    menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => openMenu(item));
        item.addEventListener('mouseleave', () => closeMenu(item));

        item.addEventListener('focusin', () => openMenu(item));
        item.addEventListener('focusout', () => closeMenu(item));
    });

    // När mus lämnar hela menyn
    if (headerMenu) {
        headerMenu.addEventListener('mouseleave', closeAllMenus);

        headerMenu.addEventListener('focusout', (e) => {
            if (!headerMenu.contains(e.relatedTarget)) {
                closeAllMenus();
            }
        });
    }

    // ESC stänger alla menyer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllMenus();

            if (window.location.hash === '#header-menu') {
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        }
    });

    // När sidan laddas med hash #header-menu
    if (window.location.hash === '#header-menu') {
        triggerFirstMenu();
    }

    // När hash ändras (t.ex. användaren klickar på länken)
    window.addEventListener('hashchange', () => {
        if (window.location.hash === '#header-menu') {
            triggerFirstMenu();
        }
    });
});
